<template>
    <div>
        {{ msg }}
    </div>
</template>

<script>
export default {
    name: "Misc",
    data() {
        return {
            msg: 'Misc Here',
        }
    },
}
</script>

<style scoped>

</style>
